import { ValueChain } from '@upright/common/model/types';
import { ValueChainsLegend } from '@upright/ui/common/upright/model/output/scores/net-impact-chart/value-chain-legend';
import { CSSProperties } from 'react';
import { Bounds, Side } from '../../../impact-lens-profile/common/layout/types';
import { useCarouselLayout } from '../../../impact-lens-profile/context';

export function LegendArea() {
  const area = useCarouselLayout().additionalInfoArea(Side.RIGHT);
  const valueChains = [ValueChain.UPSTREAM, ValueChain.INTERNAL, ValueChain.DOWNSTREAM];
  const legendStyle = getLegendStyle(area);

  return <ValueChainsLegend valueChains={valueChains} style={legendStyle} />;
}

function getLegendStyle(area: Pick<Bounds, 'width'>): CSSProperties {
  if (area.width < 240) {
    return {
      flexDirection: 'column',
      alignItems: 'start',
      gap: 8,
    };
  }
  return {};
}
